export const Login = {
  Title: 'Login',
  Username: 'Username',
  Password: 'Password',
  Submit: 'Login',
};
